import './src/styles/globals.css'

export const onClientEntry = () => {
  // Three.js specific optimizations
  if (typeof window !== 'undefined' && window.location.pathname === '/raum') {
    // Preload Three.js only for the 360 room page
    import('@react-three/fiber').catch(() => {
      console.warn('Failed to preload Three.js')
    })
  }
}